module.exports = __webpack_public_path__ + "img/Mask Group 53.3c3fa6cd.png";